import { render, staticRenderFns } from "./MaterialInputItem.vue?vue&type=template&id=0ed0ba3e&scoped=true&"
import script from "./MaterialInputItem.vue?vue&type=script&lang=ts&"
export * from "./MaterialInputItem.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialInputItem.vue?vue&type=style&index=0&id=0ed0ba3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed0ba3e",
  null
  
)

export default component.exports